import React from 'react';
import { formatPhoneInput } from '../api';
import { TableRecord } from '../types';

interface Props {
  table: TableRecord;
  currentTime: number;
  onEdit: (table: TableRecord) => void;
  onDelete: (table: TableRecord) => void;
  onAdjustTime: (table: TableRecord, minutes: number) => void;
}

function formatDuration(ms: number) {
  const isNegative = ms < 0;
  const safeValue = Math.abs(ms);
  const totalSeconds = Math.floor(safeValue / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const text = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return isNegative ? `-${text}` : text;
}

const TableItem = ({ table, currentTime, onEdit, onDelete, onAdjustTime }: Props) => {
  const remainingTime = table.endTime - currentTime;

  let rowBackgroundColor = 'transparent';
  if (remainingTime < 0) {
    rowBackgroundColor = 'rgba(220, 53, 69, 0.18)';
  } else if (remainingTime < 5 * 60 * 1000) {
    rowBackgroundColor = 'rgba(255, 102, 0, 0.18)';
  } else if (remainingTime < 30 * 60 * 1000) {
    rowBackgroundColor = 'rgba(255, 243, 5, 0.22)';
  }

  return (
    <tr style={{ backgroundColor: rowBackgroundColor }}>
      <td><strong>{table.tableNumber}</strong></td>
      <td>{table.name}</td>
      <td>{formatPhoneInput(table.phone)}</td>
      <td>{table.partySize}명</td>
      <td style={{ color: remainingTime < 0 ? 'var(--danger-color)' : 'inherit', fontWeight: 600 }}>
        {formatDuration(remainingTime)}
      </td>
      <td className="table-actions">
        <button type="button" onClick={() => onAdjustTime(table, -10)}>-10분</button>
        <button type="button" onClick={() => onAdjustTime(table, 10)}>+10분</button>
        <button type="button" onClick={() => onEdit(table)}>수정</button>
        <button type="button" className="danger" onClick={() => onDelete(table)}>삭제</button>
      </td>
    </tr>
  );
};

export default TableItem;
